import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FileDataBatchResponse } from '@/uppy-file-upload/schemas'

export interface UserFilesPollingSource {
  fileIds: string[]
}

export interface UserFilesPollingState {
  isRunning: boolean
  pollCount: number
  lastPollTimestamp: number | null
  runId: number
  sourcesById: Record<string, UserFilesPollingSource>
}

const initialState: UserFilesPollingState = {
  isRunning: false,
  pollCount: 0,
  lastPollTimestamp: null,
  runId: 0,
  sourcesById: {},
}

export const userFilesPollingSlice = createSlice({
  name: 'userFilesPollingState',
  initialState,
  reducers: {
    upsertPollingSource: (
      state,
      action: PayloadAction<{
        sourceId: string
        fileIds?: string[]
      }>
    ) => {
      state.sourcesById[action.payload.sourceId] = {
        fileIds: action.payload.fileIds ?? [],
      }
    },

    processorStarted: (state) => {
      state.isRunning = true
      state.runId += 1
    },

    removePollingSource: (state, action: PayloadAction<{ sourceId: string }>) => {
      delete state.sourcesById[action.payload.sourceId]
    },

    processorStopped: (state) => {
      state.isRunning = false
      state.pollCount = 0
      state.lastPollTimestamp = null
    },

    pollCompleted: (state) => {
      state.pollCount += 1
      state.lastPollTimestamp = Date.now()
    },

    pollBatchReceived: (
      _state,
      _action: PayloadAction<{
        requestedIds: string[]
        files: FileDataBatchResponse['files']
      }>
    ) => {
      // Consumed by source-owned listeners in later phases
    },
  },
})

export const UserFilesPollingActions = userFilesPollingSlice.actions
export default userFilesPollingSlice.reducer
